import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ResidentEnrollmentInterceptor } from './interceptors/http.interceptor';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HeaderComponent } from '@shared/components/header/header.component';
import { RouterModule } from '@angular/router';
import { FooterComponent } from '@shared/components/footer/footer.component';
import { InstitutionTitleComponent } from './components/institution-title/institution-title.component';

const entryComponents = [
];
const formFieldComponents = [
];

const components = [
  HeaderComponent,
  FooterComponent,
  InstitutionTitleComponent,
];
const pipes = [
];

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ResidentEnrollmentInterceptor,
      multi: true
    }
  ],
  declarations: [...components, ...entryComponents, ...pipes, ...formFieldComponents],
  entryComponents: [...entryComponents],
  exports: [...components, ...entryComponents, ...pipes, ...formFieldComponents]
})
export class SharedModule { }
